import { Link } from "react-router-dom";
import { Scale, ArrowLeft } from "lucide-react";
import LegalText from "@/components/LegalText";

export default function LegalPage() {
  return (
    <div className="max-w-[860px] mx-auto px-4 sm:px-8 py-8" data-testid="legal-page">
      <Link to="/" className="inline-flex items-center gap-1 text-xs font-mono text-bt-text-tertiary hover:text-bt-gold mb-4" data-testid="legal-back">
        <ArrowLeft className="w-3.5 h-3.5" /> Back
      </Link>
      <div className="bg-bt-surface border border-bt-border-subtle p-6 sm:p-10">
        <div className="flex items-center gap-3 mb-2">
          <Scale className="w-6 h-6 text-bt-gold" strokeWidth={1.5} />
          <h1 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tight text-bt-text-primary">Disclaimer &amp; Copyright</h1>
        </div>
        <p className="text-sm text-bt-text-tertiary mb-8">Please read carefully. By using Rockafeller Jones you agree to the terms below.</p>
        <LegalText />
      </div>
    </div>
  );
}
